import { Box, Divider, Stack, Typography } from "@mui/material"

export function RejectionDecisionCounts({ approvedCount = 0, rejectedCount = 0 }) {
    const hasDecisionCounts = approvedCount > 0 || rejectedCount > 0
    if (!hasDecisionCounts) return null

    return (
        <Box sx={{ mt: 1.5 }}>
            <Divider sx={{ borderColor: "grey.300", mb: 1 }} />
            <Stack direction="row" justifyContent="space-between" spacing={2}>
                <Typography variant="caption" sx={{ color: "success.main", fontWeight: 600 }}>
                    {approvedCount} Approved
                </Typography>
                <Typography variant="caption" sx={{ color: "error.main", fontWeight: 600 }}>
                    {rejectedCount} Rejected
                </Typography>
            </Stack>
        </Box>
    )
}
